export enum RecurrenceType {
  Advanced = 'Advanced',
  Hourly = 'Hourly',
  Interval = 'Interval',

  Weekly = 'Weekly',
  Monthly = 'Monthly',
}
